/* eslint-disable import/no-internal-modules */
import { CartIconButtonMobileV3 } from "user_site/features/cart";
import { WithProviders } from "user_site/utils";

const Component = () => (
  <WithProviders>
    <CartIconButtonMobileV3 />
  </WithProviders>
);

export default Component;
